import * as Sentry from "@sentry/react"
import React from "react"
import ReactDOM from "react-dom/client"
import "@/global.css"
import Routes from "./routes.tsx"
import {
  useLocation,
  useNavigationType,
  createRoutesFromChildren,
  matchRoutes,
} from "react-router-dom"
import AuthenticationProvider from "@/authentication/authentication.provider.tsx"
import { QueryClientProvider } from "@tanstack/react-query"
import { queryClient } from "@/api/query-client"

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  release: import.meta.env.VITE_RELEASE,
  environment: import.meta.env.VITE_ENV,
  integrations: [
    Sentry.reactRouterV6BrowserTracingIntegration({
      useEffect: React.useEffect,
      useLocation,
      useNavigationType,
      createRoutesFromChildren,
      matchRoutes,
    }),
  ],
})

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <AuthenticationProvider>
      <QueryClientProvider client={queryClient}>
        <Routes />
      </QueryClientProvider>
    </AuthenticationProvider>
  </React.StrictMode>,
)
